var currentPreview = null;
var currentFile = null;

$(document).ready(function() {
    var files = document.getElementsByClassName('dropbox__items__file');

    for (var i = 0; i < files.length; i++)
    {
        var file = files[i];
        file.addEventListener( 'click', onFileClick );
    }

    var closables = document.querySelectorAll('.dropbox__preview__close a');

    for (i = 0; i < closables.length; i++)
    {
        var closable = closables[i];
        closable.addEventListener( 'click', onCloseClick );
    }
});

function onFileClick(e) {
    var file = e.currentTarget;
    var preview = file.getElementsByClassName( 'dropbox__preview' )[0];

    openPreview(preview);
    activateFile(file);

    e.stopPropagation();
}

function onCloseClick(e) {
    closePreview(currentPreview);
    inactivateFile(currentFile);

    e.stopPropagation();
}

function onDocumentClick(e) {
    if (currentPreview === null || e.target === currentPreview || isChildOf( e.target, currentPreview)) {
        return;
    }

    closePreview(currentPreview);
    inactivateFile(currentFile);
}

function isChildOf( a, b ) {
    var parent = a.parentNode;

    while (parent) {
        if (parent === b) {
            return true;
        }

        parent = parent.parentNode;
    }

    return false;
}

function openPreview(preview) {
    closePreview(currentPreview);
    inactivateFile(currentFile);
    preview.style.display = 'block';
    showThumbnail(preview);
    currentPreview = preview;
    $(document).click(onDocumentClick);
}

function showThumbnail( preview )
{
    var thumbnail = preview.getElementsByClassName( 'dropbox__preview__thumbnail' )[0];

    if (thumbnail) {
        thumbnail.style.background = 'url(' + thumbnail.dataset.image + ') center center no-repeat';
        thumbnail.style.backgroundSize = '100% auto';
    }
}

function closePreview( preview ) {

    if (preview) {
        preview.style.display = 'none';
        currentPreview = null;
        $(document).click(null);
    }
}

function activateFile(file)
{
    currentFile = file;
    var link = file.getElementsByClassName( 'dropbox__items__item__link' )[0];
    $(link).addClass('dropbox__items__item__link-active');

}

function inactivateFile(file)
{
    if (file) {
        var link = file.getElementsByClassName( 'dropbox__items__item__link' )[0];
        $(link).removeClass('dropbox__items__item__link-active');
        currentFile = null;
    }
}
